"use strict";import{tag as s}from"../custom-tag.js";export function slideArrowIcon({height:r=16,width:t=16,hidden:e=!1,title:l="Slide arrow"}={}){return s`
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width=${t}
      height=${r}
      fill="currentColor"
      viewBox="0 0 24 24"
      aria-hidden="${e?"true":"false"}"
      role="img"
      aria-label="${l}"
    >
      <mask
        id="slide-arrow_svg__mask0_3955_285"
        width="15"
        height="22"
        x="5"
        y="1"
        maskUnits="userSpaceOnUse"
        style="mask-type:alpha"
      >
        <g stroke="currentColor">
          <path
            fill="currentColor"
            stroke-width=".25"
            d="m19.64 2.889.087-.088-.088-.089-.8-.8-.089-.089-.088.089-9.585 9.584a.69.69 0 0 0 0 .977l9.615 9.615.088.089.088-.089.8-.8.09-.088-.09-.089-9.125-9.126z"
          />
          <path stroke-width="1.5" d="M5.75 5v14" />
        </g>
      </mask>
      <g mask="url(#slide-arrow_svg__mask0_3955_285)">
        <path fill="currentColor" d="M24 0H0v24h24z" />
      </g>
    </svg>
  `}
//# sourceMappingURL=slideArrow.js.map
